import { useTranslation } from 'react-i18next';
import DateRangePicker from '@lib/components/DateTimePicker/DateRangePicker';
import { InputSizes } from '@lib/components/Input/enums';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import styles from './AnalyticsPeriodFilter.module.scss';

interface Props {
  value: string[];
  onChange: (v: string[] | null | undefined) => void;
}

export default function AnalyticsPeriodFilter({ value, onChange }: Props) {
  const { t } = useTranslation();
  // The picker can emit `[]` on clear even with `allowClear={false}`; bubble
  // that as `null` so the parent restores the default period instead of
  // persisting an empty range.
  const handleChange = (next: string[]) => {
    if (!next || !next[0] || !next[1]) {
      onChange(null);
      return;
    }
    onChange(next);
  };
  return (
    <PageBody withoutHeader paddingBottom="none">
      <WhiteBox verticalPaddings="extraSmall" horizontalPaddings="small">
        <div className={styles.root}>
          <div className={styles.dateRangePickerCol}>
            <DateRangePicker
              label={t('period')}
              onChange={handleChange}
              size={InputSizes.medium}
              value={value}
              allowClear={false}
            />
          </div>
        </div>
      </WhiteBox>
    </PageBody>
  );
}
